import React from 'react';

const RoomCard = ({ room, isJoining, onJoinRoom, canJoin = true, roomType = 'cafe', onCtaClick, onSeeDetails }) => (
  <div className="room-card">
    {room.event_banner_url && (
      <div className="room-card-image">
        <img src={room.event_banner_url} alt={room.name} />
      </div>
    )}
    <div className="room-title">{room.name}</div>
    <div className="room-meta">
      {(room.language || room.level) && (
        <div className="room-language-line">
          {room.language}
          {room.language && room.level && ' • '}
          {room.level && `Level: ${room.level}`}
        </div>
      )}
      {room.description && (
        <div className="room-description">
          {room.description.length > 140 ? `${room.description.slice(0, 137)}…` : room.description}
        </div>
      )}
      {room.isEvent && (room.date || room.time) && (
        <div className="room-datetime">
          {room.date && <span>{room.date}</span>}
          {room.date && room.time && ' • '}
          {room.time && <span>{room.time}</span>}
        </div>
      )}
    </div>
    <div className="room-chips">
      {room.language && <span className="chip">{room.language}</span>}
      {room.level && <span className="chip">{room.level}</span>}
      {room.isEvent && <span className="chip">Event</span>}
    </div>
    <div className="room-participants">
      <div className="room-avatars">
        {(room.previewParticipants || []).map((p, idx) => (
          p.avatar_url ? (
            <img key={idx} className="room-avatar img" src={p.avatar_url} alt={p.name} title={p.name} />
          ) : (
            <div key={idx} className="room-avatar" title={p.name}>{p.initial}</div>
          )
        ))}
        {typeof room.participants === 'number' && room.participants > (room.previewParticipants?.length || 0) && (
          <div className="room-avatar more">+{room.participants - (room.previewParticipants?.length || 0)}</div>
        )}
      </div>
      <span className="room-participants-count">
        {typeof room.participants === 'number' ? `${room.participants} participant${room.participants === 1 ? '' : 's'}` : null}
      </span>
    </div>

    <div className="room-card-actions">
      <button
        type="button"
        className="room-card-secondary-btn"
        onClick={() => onSeeDetails && onSeeDetails({ ...room, roomType })}
      >
        See Details
      </button>

      <button
        className={`join-room-button${isJoining ? ' loading' : ''}${!canJoin ? ' disabled' : ''}`}
        onClick={() => canJoin && onJoinRoom(room.id)}
        disabled={isJoining || !canJoin}
        title={!canJoin && roomType !== 'cafe'
          ? (roomType === 'group'
            ? 'Join this group from the Groups page to access its virtual room.'
            : 'Join this event from the Events page to access its virtual room.')
          : undefined}
      >
        {isJoining ? 'Joining…' : 'Join Room'}
      </button>

      {!canJoin && roomType !== 'cafe' && (
        <button
          type="button"
          className="join-parent-entity-button"
          onClick={onCtaClick}
        >
          {roomType === 'group' ? 'Join Group' : 'Join Event'}
        </button>
      )}
    </div>
  </div>
);

export default RoomCard;